import db from "../driverappdb";

export const ParamRepository = {
    getParams: () => db.params.orderBy('id').desc().first()
};